declare namespace $ {

	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_echarts_1 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_float_settings_echarts_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['table_head'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_echarts_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['axis'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_echarts_4 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_settings_echarts_5 = $mol_type_enforce<
		({ 
			'day': string,
			'month': string,
			'year': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_echarts_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['axis_details'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_settings_echarts_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_echarts_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_echarts_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['Axis_content'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_echarts_10 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__options_shm_hitalama_map_widget_float_settings_echarts_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['table_head'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_echarts_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['values_title'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_echarts_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_echarts_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['Values'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select_list__value_shm_hitalama_map_widget_float_settings_echarts_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['groups'] >
		,
		ReturnType< $mol_select_list['value'] >
	>
	type $mol_select_list__options_shm_hitalama_map_widget_float_settings_echarts_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['table_head'] >
		,
		ReturnType< $mol_select_list['options'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_echarts_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_echarts_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['Groups'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_settings_echarts_19 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_settings_echarts_20 = $mol_type_enforce<
		({ 
			'line': string,
			'bar': string,
			'scatter': string,
			'pie': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_settings_echarts_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['chart_type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_echarts_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_echarts_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['Type'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_echarts_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_echarts_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['legend_show'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_echarts_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_echarts_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['smooth'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_echarts_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_echarts_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['area'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_echarts_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_echarts_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['stacked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_echarts_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_echarts_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['toolbox_show'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_echarts_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_echarts_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_echarts['data_zoom_show'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_hitalama_map_widget_float_settings_echarts extends $shm_hitalama_map_widget_float_settings {
		table_head( ): readonly(any)[]
		axis( next?: string ): string
		Axis( ): $mol_select
		axis_details( next?: string ): string
		Axis_details( ): $mol_select
		axis_details_visible( ): readonly(any)[]
		Axis_content( ): $mol_view
		Axis_field( ): $mol_form_field
		values_title( next?: string ): string
		Values( ): $mol_select
		Values_field( ): $mol_form_field
		groups( next?: readonly(any)[] ): readonly(any)[]
		Groups( ): $mol_select_list
		Groups_field( ): $mol_form_field
		chart_type( next?: string ): string
		Type( ): $mol_select
		Type_field( ): $mol_form_field
		legend_show( next?: boolean ): boolean
		Legend( ): $mol_check_box
		smooth( next?: boolean ): boolean
		Smooth( ): $mol_check_box
		area( next?: boolean ): boolean
		Area( ): $mol_check_box
		stacked( next?: boolean ): boolean
		Stack( ): $mol_check_box
		toolbox_show( next?: boolean ): boolean
		Toolbox( ): $mol_check_box
		data_zoom_show( next?: boolean ): boolean
		Data_zoom( ): $mol_check_box
		controls( ): readonly(any)[]
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=echarts.view.tree.d.ts.map